import React from 'react'

const NoData = () => {
  return (
    <div>There are no permissions given to your role for further information please contact our RS_ADMIN</div>
  )
}

export default NoData